var caches = []
var MAX_CACHE = 10

function parseIPhoneX(UA, isNode) {
    var model = ''
    if (/(iPhone\/)?iPhone\s?(X|1[1-4])/.test(UA)) { // 通过UA判断(点评容器、大象)
        model = 'iPhoneX'
    }else if (/(iPhone\/)?iPhone\s?(X|15[2,3])/.test(UA)) { // 通过UA判断(点评容器、大象)
        model = 'iPhoneIsland'
    } else if (!isNode) { // 浏览器中无法通过UA检测出iphonex系列
        if (/iPhone/.test(UA)) { // 通过ua加屏幕宽高判断
            // https://developer.apple.com/design/human-interface-guidelines/ios/visual-design/adaptivity-and-layout/
            // iPhone X      @3x 1125px × 2436px => 375pt x 812pt
            // iPhone XS     @3x 1125px × 2436px => 375pt x 812pt
            // iPhone XS Max @3x 1242px × 2688px => 414pt x 896pt
            // iPhone XR     @2x 828px × 1792px  => 414pt x 896pt
            // iPhone 11     @2x 828px x 1792 px => 414pt x 896pt
            // iPhone 11 Pro @3x 1125px x 2436 px => 375pt x 812pt
            // iPhone 11Pro Max  @3x 1242px x2688px => 414pt x 896pt
            // iPhone 12 mini    @3x 1125px x 2436px => 375pt x 812pt
            // iPhone 12         @3x 1170px x2532px => 390pt x 844pt 
            // iPhone 12 Pro     @3x 1170px x2532 px => 390pt x 844pt
            // iPhone 12 Pro Max @3x 1170px x2532 px => 428pt x 926pt
            // Portrait/Landscape 
            if (screen) {
                var screenHeight = screen.height
                var screenWidth = screen.width
                if (screenHeight === 812 || screenWidth === 812) { // iPhoneX/iPhoneXS/iPhone11Pro/iPhone12mini
                    model = 'iPhoneX'
                } else if (screenHeight === 896 || screenWidth === 896) { // iPhoneXR/iPhoneXSMax/iPhone11/iPhone11ProMax
                    model = 'iPhoneXR'
                    if (devicePixelRatio) {
                        if (devicePixelRatio === 3) {
                            model = 'iPhoneXSMax'
                        }
                    }
                } else if (screenHeight === 844 || screenWidth === 844) { // iPhone12/iPhone12Pro
                    model = 'iPhone12'
                } else if (screenHeight === 926 || screenWidth === 926) { // iPhone12ProMax
                    model = 'iPhone12ProMax'
                } else if ((screenHeight === 393 && screenWidth === 852) || (screenHeight === 852 && screenWidth === 393)) { // iPhone14Pro
                    model = 'iPhone14Pro'
                } else if ((screenHeight === 430 && screenWidth === 932) || (screenHeight === 932 && screenWidth === 430)) { // iPhone14ProMax
                    model = 'iPhone14ProMax'
                }
            }
        }
    }
    return model
}

module.exports = function parseUA(UA, HOST, isNode) {
    for (var index = 0; index < caches.length; index++) {
        var cache = caches[index];
        if (cache && cache.ua === UA && cache.host === HOST && cache.result instanceof Object) {
            cache.result.isCache = true
            return cache.result
        }
    }

    var result = {
        isCache: false
    };
    var type;
    var version;
    var os;
    var osVersion;
    var kernal;
    var source;
    var env;
    var model;

    function match(reg) {
        if (reg) {
            if (UA.match(reg) && UA.match(reg).length) {
                return UA.match(reg)[1];
            }
        }
    }

    function matchTypeVersion(reg) {
        if (reg) {
            if (UA.match(reg) && UA.match(reg).length >= 2) {
                return UA.match(reg);
            } else {
                return ['', '0.0.0'];
            }
        }
    }

    function isMobile() {
        var check = false;
        if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(UA) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(UA.substr(0, 4))) check = true
        return check;
    }

    try {
        if (!UA) return
        //mobile detect
        result.isMobile = isMobile();

        //os detect
        if (UA.match(/android/i)) {
            result.os = 'android';

            result.osVersion = match(/Android\/([\d\.]+)/i) || match(/Android ([\d\.]+)/);

            result.kernal = match(/AppleWebKit\/([\d\.]+)/i);

            result.browserVersion = match(/Chrome\/([\d\.]+)/i);
        } else if (UA.match(/(ipad|iphone|ipod).*os\s([\d_]+)/i)) {
            result.os = 'ios';

            result.osVersion = match(/iOS\/([\d\.]+)/) || match(/OS ([\d\_]+)/).split('_').join('.');

            result.kernal = match(/AppleWebKit\/([\d\.]+)/i);

            result.browserVersion = match(/Safari\/([\d\.]+)/i);
        }

        //判断容器环境，因为关键字匹配不一定准确，所以优先判断公司内APP的容器类型
        if (/dp\/com\.dianping/.test(UA)) {
            var arr = matchTypeVersion(/dp\/com\.dianping\.([\w\.]+)\/([\d\.]+)/);
            var typeKey = arr[1];
            version = arr[2];
            //判断点评系APP
            if (typeKey.indexOf('dpscope') !== -1) {
                type = 'dpapp';
            } else if (typeKey.indexOf('v1') !== -1) {
                type = 'dpapp'
                if (/adapter\/([\d\.]+)/.test(UA)) {
                    version = match(/adapter\/([\d\.]+)/);
                }
            } else if (typeKey.indexOf('wedmerchant') !== -1) {
                type = 'dpwedmerchant'
            } else if (typeKey.indexOf('merchant') !== -1 || typeKey === 'mp.mobile' || typeKey.indexOf('dppos') !== -1) {
                type = 'dpmerchant';
            } else if (typeKey.indexOf('wed') !== -1) {
                type = 'dpwed';
            } else {
                type = 'dp';
            }

        } else if (/MeituanGroup/i.test(UA)) {
            //判断美团APP
            type = 'mtgroup';

            var arr = matchTypeVersion(/(MeituanGroup)\/([\d\.]+)/i);
            version = arr[2];

        } else if (/meituanwaimai-c/i.test(UA)) {
            //判断美团外卖APP
            type = 'meituanwaimai';
            version = match(/meituanwaimai-c\/([\d\.]+)/i);
        }else if(/merchant/i.test(UA)) {
            //判断开店宝APP
            type = 'merchant';
            version = match(/merchant\/([\d\.]+)/i);
        } else if(/(meituanwaimai-b|meituanwaimaibusiness)/i.test(UA)) {
            //判断外卖商家端
            type = 'meituanwaimaibusiness';
            if(/meituanwaimai-b/i.test(UA)) {
                version = match(/meituanwaimai-b\/([\d\.]+)/i);
            } else {
                version = match(/meituanwaimaibusiness\/([\d\.]+)/i);
            }
        } else if (/KLMall/i.test(UA)) {
            //判断快驴APP
            type = 'klmall';
            version = match(/KLMall\/[\w\.]*\/([\d\.]+)/i);
        } else if(/erpbosspro/i.test(UA)) {
            //判断收银APP
            type = 'erpbosspro';
            version = match(/erpbosspro\/[\w\.]*\/([\d\.]+)/i);
        }  else if (/MicroMessenger/.test(UA)) {
            //判断微信APP
            if(/dplite/.test(UA)) {
                type = 'dplite';
                version = match(/dplite\/([\d\.]+)/i)
            } else {
                type = 'weixin'
                version = match(/MicroMessenger\/([\d\.]+)/i);
            }
        } else if (/QZONE/.test(UA)) {
            type = 'qqzone';
            version = match(/QZONEJSSDK\/([\d\.]+)/);

        } else if (/QQ\/([\d\.]+)/.test(UA)) {
            type = 'qq';
            version = match(/QQ\/([\d\.]+)/i);

        } else if (/UCWEB/i.test(UA)) {
            type = 'ucweb';
            version = match(/UCWEB([\d\.]+)/i);

        } else if (/weibo/i.test(UA)) {
            type = 'weibo';
            version = match(/weibo__([\d\.]+)/i);
        } else {
            type = 'browser';
        }

        //区分业务：点评OR美团
        if (/\.(dianping|dpfile)\.com/i.test(HOST)) {
            source = 'dianping';
            env = 'product';
        } else if (/\.51ping\.com/i.test(HOST)) {
            source = 'dianping';
            env = 'beta';
        } else if (/test(.*)\.(meituan|sankuai)\.(com|net)/i.test(HOST)) {
            source = 'meituan';
            env = 'beta';
        } else if (/\.(meituan|sankuai)\.(com|net)/i.test(HOST)) {
            source = 'meituan';
            env = 'product';
        }

        model = parseIPhoneX(UA, isNode)

        result.type = type;
        result.version = version;
        result.source = source;
        result.env = env;
        result.model = model;

    } catch (e) {
        console.log(e);
        result.type = type;
        result.version = version;
    }

    var newCache = {
        ua: UA,
        host: HOST,
        result: result
    }
    if (caches.length < MAX_CACHE) {
        caches.push(newCache)
    } else {
        caches.shift()
        caches.push(newCache)
    }

    return result
};